<template>
  <div class="project-card-expanded-trials">
    <div
      class="trial"
      v-for="(trial, tIndex) in trialList"
      :key="trial.id + '-' + tIndex"
      @click.stop="goToTrial(projectId, trial.id)"
    >
      <div class="trial-name">{{ trial.name || 'Untitled trial' }}</div>
      <div class="trial-status" :class="[trial.status]">
        <div class="trial-status-text">{{ $t("status_" + trial.status) }}</div>
        <div
          class="trial-link"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCardtrialsList',
  props: ['projectId', 'trialList'],
  methods: {
    goToTrial(projectId, trialId) {
      this.$router.push({path: `/project/${projectId}/trial/${trialId}`})
    }
  }
}
</script>

<style lang="stylus" scoped>
.project-card-expanded-trials
  background-color: $mystic
  border-left: 1px solid rgba($heather, 0.5)
  border-right: 1px solid rgba($heather, 0.5)
  display: flex
  flex: 1 1 0%
  flex-direction: column
  overflow-y: auto

  .project-card-footer &
    border: none

    .trial
      &:last-child
        border: none

  .trial
    align-items: center
    // border-bottom: 1px solid rgba($heather, 0.5)
    display: flex
    flex: 0 0 30px
    height: 30px
    m-font-size(10, 14)
    cursor: pointer
    &:hover
      background $titan-white
      border-top 1px solid $mystic
      border-bottom 1px solid $mystic

    .trial-name
      flex: 1 1 0%
      m-ellipsis(90%)
      margin-left: 20px
      margin-right: 20px
      // text-transform: uppercase

    .trial-status
      align-items: center
      display: flex
      flex: 0 0 60px
      margin-right: 20px

      &.ready
        color: $trial-ready

      &.running
        color: $trial-running
      
      &.submitted
        color: $trial-submitted

      &.paused
        color: $trial-paused

      &.finished
        color: $trial-finished

      &.aborted
        color: $trial-aborted

      &.cancelled
        color: $trial-cancelled
      
      &.failed
        color: $trial-failed

      .trial-status-text
        m-first-letter-case()

      .trial-link
        cursor: pointer
        flex: 0 0 10px
        m-icon("arrow-right-cloud-burst", 10 8)
        margin-left: auto
        transition: transform 0.25s ease-in-out

        &:hover
          transform: translateX(4px)
</style>